import React from 'react'
import { AccordionIcon as ChakraAccordionIcon } from '@chakra-ui/react'

export const AccordionIcon: React.FC = () => <ChakraAccordionIcon />
